import { render, staticRenderFns } from "./QuickPayPageHuizhoupeixun01.vue?vue&type=template&id=3abbd3b4&scoped=true"
import script from "./QuickPayPageHuizhoupeixun01.vue?vue&type=script&lang=js"
export * from "./QuickPayPageHuizhoupeixun01.vue?vue&type=script&lang=js"
import style0 from "./QuickPayPageHuizhoupeixun01.vue?vue&type=style&index=0&id=3abbd3b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abbd3b4",
  null
  
)

export default component.exports